"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const providers_1 = require("../../providers");
function GuidesButton({ className }) {
    const [, setGuidesState] = (0, providers_1.useGuidesContext)();
    const onClick = () => {
        setGuidesState(prev => (Object.assign(Object.assign({}, prev), { isGuidesExpanded: true })));
    };
    return ((0, jsx_runtime_1.jsx)(StyledButton, { className: className, onClick: onClick, "data-e2e": 'GuidesButton_StyledButton', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Grid, "data-e2e": 'GuidesButton_StyledIcon' }) }));
}
exports.default = GuidesButton;
const StyledButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.white};

  background: ${({ theme }) => theme.green};

  border-radius: 50%;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;

  margin: auto;
`;
